;(function () {
  'use strict'

  // This file monkeypatches `XMLHttpRequest` to insert a header with the Rails
  // `X-CSRF-Token` header. It's common to insert the header using jQuery's
  // `beforeSend` hook, but that doesn't apply to XHRs that are made without
  // using jQuery.
  //
  // `XMLHttpRequest` doesn't have mechanisms to do this cleanly, so
  // monkeypatching is about the best option available.

  var xhrPrototype = window.XMLHttpRequest.prototype
  var rejectedUrlPattern = /^(\/assets\/|socket\.io)/

  // Test if requested URL matches any non-monolith services
  // Patterns taken from Traefik rules
  function isServiceRoute(route) {
    return [
      /^\/api\/v1\/(asset_proxy|pusher|snapshots)/i,
      /^\/(assets|workflows)\/v2/i,
      /^\/oauth2/i,
      /^\/monolith-frontend/i,
    ].some(function (pattern) {
      return pattern.test(route)
    })
  }

  // Without this, the methods will be monkeypatched to point to the
  // monkeypatched versions, and the real versions will never be called.
  //
  // @note The entire block must be wrapped in the `if` statement. If the 'only
  //   monkeypatch if it's not already monkeypatched' logic is placed at the
  //   end of the file, `xhrPrototype.originalOpen = xhrPrototype.open` will
  //   capture the monkeypatched version instead of the browser implementation.
  //   I don't know why; to me that seems like code having effects in the past.
  //   Monkeypatching is inherently fragile, though.
  if (!xhrPrototype.monkeypatched) {
    function shouldSendWithCSRF() {
      // `withCredentials` means the request is cross-domain; the CSRF token
      // shouldn't be sent to external domains.
      //
      // @see https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/withCredentials
      if (this.withCredentials) return false

      // Without this check Juggernaut won't load -- `XMLHttpRequest cannot load
      // <URL for Juggernaut>. Request header field X-CSRF-Token is not allowed
      // by Access-Control-Allow-Headers in preflight response.`
      //
      // Todo: now that juggernaut is removed, is this still needed?
      // @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Access_control_CORS#Preflighted_requests
      if (rejectedUrlPattern.test(this.opal_url)) return false

      // `this.withCredentials` *should* catch any cross-domain requests, but
      // some are allowed through. This test explicitly detects cross-origin
      // requests -- meaning the protocol, domain, or port doesn't match the
      // page the user is viewing.
      if (!this.opal_url.includes(window.location.origin)) return false

      return true
    }

    // @see https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open
    xhrPrototype.originalOpen = xhrPrototype.open
    // Normally there's no way to determine the URL from inside the XHR instance,
    // but it's important to know the URL for cases where sending the CSRF token
    // header will caue the request to fail.
    function openStoringUrl(_, url) {
      // `url` may be a relative path (e.g. `/users`), but `shouldSendWithCSRF`
      // works best if given a fully qualified URL. An `<a>` element's `href`
      // property always provides the fully qualified URL.
      //
      // @note This creates a new DOM node on each invocation instead of caching
      //   a single instance as a safety measure against race conditions.
      var urlTag = document.createElement('a')
      urlTag.href = url
      this.opal_url = urlTag.href

      // Patch url argument to begin with /legacy while
      // monolith is served in embedded mode
      // Skip over any absolute routes, or routes that map to non-monolith services
      if (
        window.embedded &&
        arguments[1].indexOf('/') === 0 &&
        arguments[1].indexOf('/legacy') !== 0 &&
        !isServiceRoute(arguments[1])
      ) {
        arguments[1] = '/legacy' + arguments[1]
      }

      this.originalOpen.apply(this, arguments)
    }

    // @see https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/send
    xhrPrototype.originalSendFunction = xhrPrototype.send
    // @note This needs to be the *only* code that sets the `X-CSRF-Token` header.
    //   If multiple places set the header the token will be appended to the
    //   existing header, separated by a comma (`X-CSRF-Token: foo, foo`).
    function sendWithCSRF(data) {
      var tokenEl = document.querySelectorAll('meta[name=csrf-token]')[0]
      var token

      if (tokenEl && shouldSendWithCSRF.call(this)) {
        token = tokenEl.getAttribute('content')
        this.setRequestHeader('X-CSRF-Token', token)
      }

      this.originalSendFunction(data)
    }

    xhrPrototype.open = openStoringUrl
    xhrPrototype.send = sendWithCSRF
    xhrPrototype.monkeypatched = true
  }
})()
